import { FC } from 'react';
import { observer } from 'mobx-react';

import { useDependencies } from '@servicetitan/react-ioc';
import { SingleOptionProps } from '@servicetitan/design-system';

import { OptOutFilterType } from '../api/telecom.api';
import { GlobalOptOutStore } from '../stores/global-opt-out.store';
import { MultiValueFilter } from '../../components/tenants/multi-value-filter/multi-value-filter';

const optInFilterOptions: SingleOptionProps[] = [
    {
        value: OptOutFilterType.OptedIn,
        label: 'Opted In',
    },
    {
        value: OptOutFilterType.OptedOut,
        label: 'Opted Out',
    },
];

export const OptInStatusFilter: FC = observer(() => {
    const [store] = useDependencies(GlobalOptOutStore);

    const handleApply = (selectedValues: OptOutFilterType[]) => {
        store.filterByOptInStatus(selectedValues);
    };

    return (
        <MultiValueFilter
            label="Opt-In Status"
            onApply={handleApply}
            options={optInFilterOptions}
            appliedValues={store.optInFilter}
        />
    );
});
